import {
	FETCH_ENTRETIENS_BEGIN,
	FETCH_ENTRETIENS_ERROR,
	FETCH_ENTRETIENS_SUCCESS,
	POST_ENTRETIEN_BEGIN,
	POST_ENTRETIEN_ERROR,
	POST_ENTRETIEN_RESET,
	POST_ENTRETIEN_SUCCESS,
	DELETE_ENTRETIEN_BEGIN,
	DELETE_ENTRETIEN_ERROR,
	DELETE_ENTRETIEN_RESET,
	DELETE_ENTRETIEN_SUCCESS,
	FETCH_CALENDAR_ENTRETIENS_BEGIN,
	FETCH_CALENDAR_ENTRETIENS_ERROR,
	FETCH_CALENDAR_ENTRETIENS_SUCCESS,
	POST_ENT_TO_ATELIER_BEGIN,
	POST_ENT_TO_ATELIER_ERROR,
	POST_ENT_TO_ATELIER_RESET,
	POST_ENT_TO_ATELIER_SUCCESS,
	FETCH_ENTRETIENS_SEMAINE_BEGIN,
	FETCH_ENTRETIENS_SEMAINE_ERROR,
	FETCH_ENTRETIENS_SEMAINE_SUCCESS,
	UPDATE_VEHICULE_KMS_BEGIN,
	UPDATE_VEHICULE_KMS_ERROR,
	UPDATE_VEHICULE_KMS_SUCCESS,
	UPDATE_VEHICULE_KMS_RESET,
	FETCH_HISTORIQUE_ENTRETIEN_BEGIN,
	FETCH_HISTORIQUE_ENTRETIEN_ERROR,
	FETCH_HISTORIQUE_ENTRETIEN_SUCCESS,
	DECALER_ECHEANCE_BEGIN,
	DECALER_ECHEANCE_ERROR,
	DECALER_ECHEANCE_SUCCESS,
	DECALER_ECHEANCE_RESET,
} from "../actions/entretienActions"

const initialState = {
	// Tous les cycles ouverts (1 ligne = véhicule × plan), triés par urgence.
	echeances: [],
	// Un plan par Entretien (portée, cycle, compteurs par statut, champs d'édition).
	plans: [],
	// Cycles du plan × véhicule ouvert dans le tiroir, du plus ancien au plus récent.
	historique: [],
	entretiensRetard: 0, // semaines passées (rouge)
	entretiensSemaine: 0, // à faire cette semaine (jaune)
	entretiensAVenir: 0, // au-delà de cette semaine (vert)
	calendar: {},
	createdAtelier: 0,
	fetchEntretiensSemaine: {
		loading: false,
		error: false,
	},
	fetchCalendar: {
		loading: false,
		error: false,
	},
	fetchEntretiens: {
		loading: false,
		error: false,
	},
	postEntretien: {
		saving: false,
		saved: false,
		error: false,
	},
	deleteEntretien: {
		deleting: false,
		deleted: false,
		error: false,
	},
	createAtelier: {
		creating: false,
		created: false,
		error: false,
	},
	updateKms: {
		saving: false,
		saved: false,
		error: false,
	},
	fetchHistorique: {
		loading: false,
		error: false,
	},
	decalerEcheance: {
		saving: false,
		saved: false,
		error: false,
	},
}

export default function entretienReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_ENTRETIENS_BEGIN:
			return {
				...state,
				fetchEntretiens: { loading: true, error: false },
			}
		case FETCH_ENTRETIENS_ERROR:
			return {
				...state,
				fetchEntretiens: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_ENTRETIENS_SUCCESS:
			return {
				...state,
				echeances: action.payload.echeances || [],
				plans: action.payload.plans || [],
				fetchEntretiens: { loading: false, error: false },
			}
		case POST_ENTRETIEN_BEGIN:
			return {
				...state,
				postEntretien: { saving: true, saved: false, error: false },
			}
		case POST_ENTRETIEN_ERROR:
			return {
				...state,
				postEntretien: {
					saving: false,
					saved: false,
					error: action.payload.error,
				},
			}
		case POST_ENTRETIEN_SUCCESS:
			return {
				...state,
				echeances: action.payload.echeances || [],
				plans: action.payload.plans || [],
				postEntretien: { saving: false, saved: true, error: false },
			}
		case POST_ENTRETIEN_RESET:
			return {
				...state,
				postEntretien: { saved: false, saving: false, error: false },
			}
		case DELETE_ENTRETIEN_BEGIN:
			return {
				...state,
				deleteEntretien: {
					deleting: true,
					deleted: false,
					error: false,
				},
			}
		case DELETE_ENTRETIEN_ERROR:
			return {
				...state,
				deleteEntretien: {
					deleting: false,
					deleted: false,
					error: action.payload.error,
				},
			}
		case DELETE_ENTRETIEN_SUCCESS:
			return {
				...state,
				echeances: action.payload.echeances || [],
				plans: action.payload.plans || [],
				deleteEntretien: {
					deleting: false,
					deleted: true,
					error: false,
				},
			}
		case DELETE_ENTRETIEN_RESET:
			return {
				...state,
				deleteEntretien: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		case FETCH_CALENDAR_ENTRETIENS_BEGIN:
			return {
				...state,
				fetchCalendar: { loading: true, error: false },
			}
		case FETCH_CALENDAR_ENTRETIENS_SUCCESS: {
			const calendar = {}
			for (let ent of action.payload) {
				if (!ent.date) continue // cycles "km uniquement" : pas de date
				const key = parseInt(ent.date.substring(0, 2))
				if (calendar.hasOwnProperty(key)) calendar[key].push(ent)
				else calendar[key] = [ent]
			}
			return {
				...state,
				calendar,
				fetchCalendar: { loading: false, error: false },
			}
		}
		case FETCH_CALENDAR_ENTRETIENS_ERROR:
			return {
				...state,
				fetchCalendar: { loading: false, error: false },
			}
		// Ent To Atelier
		case POST_ENT_TO_ATELIER_BEGIN:
			return {
				...state,
				createAtelier: {
					creating: true,
					created: false,
					error: false,
				},
			}
		case POST_ENT_TO_ATELIER_ERROR:
			return {
				...state,
				createAtelier: {
					creating: false,
					created: false,
					error: action.payload.error,
				},
			}
		case POST_ENT_TO_ATELIER_SUCCESS:
			return {
				...state,
				createdAtelier: action.payload.atelier.id,
				createAtelier: {
					creating: false,
					created: true,
					error: false,
				},
			}
		case POST_ENT_TO_ATELIER_RESET:
			return {
				...state,
				createdAtelier: 0,
				createAtelier: {
					created: false,
					creating: false,
					error: false,
				},
			}
		case FETCH_ENTRETIENS_SEMAINE_BEGIN:
			return {
				...state,
				fetchEntretiensSemaine: { loading: true, error: false },
			}
		case FETCH_ENTRETIENS_SEMAINE_ERROR:
			return {
				...state,
				fetchEntretiensSemaine: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_ENTRETIENS_SEMAINE_SUCCESS:
			return {
				...state,
				entretiensRetard: action.payload.nb_retard || 0,
				entretiensSemaine: action.payload.nb_semaine || 0,
				entretiensAVenir: action.payload.nb_a_venir || 0,
				fetchEntretiensSemaine: { loading: false, error: false },
			}
		case UPDATE_VEHICULE_KMS_BEGIN:
			return {
				...state,
				updateKms: { saving: true, saved: false, error: false },
			}
		case UPDATE_VEHICULE_KMS_ERROR:
			return {
				...state,
				updateKms: {
					saving: false,
					saved: false,
					error: action.payload.error,
				},
			}
		case UPDATE_VEHICULE_KMS_SUCCESS:
			return {
				...state,
				updateKms: { saving: false, saved: true, error: false },
			}
		case UPDATE_VEHICULE_KMS_RESET:
			return {
				...state,
				updateKms: { saving: false, saved: false, error: false },
			}
		case FETCH_HISTORIQUE_ENTRETIEN_BEGIN:
			return {
				...state,
				historique: [],
				fetchHistorique: { loading: true, error: false },
			}
		case FETCH_HISTORIQUE_ENTRETIEN_ERROR:
			return {
				...state,
				fetchHistorique: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_HISTORIQUE_ENTRETIEN_SUCCESS:
			return {
				...state,
				historique: action.payload || [],
				fetchHistorique: { loading: false, error: false },
			}
		case DECALER_ECHEANCE_BEGIN:
			return {
				...state,
				decalerEcheance: { saving: true, saved: false, error: false },
			}
		case DECALER_ECHEANCE_ERROR:
			return {
				...state,
				decalerEcheance: {
					saving: false,
					saved: false,
					error: action.payload.error,
				},
			}
		case DECALER_ECHEANCE_SUCCESS:
			return {
				...state,
				echeances: action.payload.echeances || [],
				plans: action.payload.plans || [],
				decalerEcheance: { saving: false, saved: true, error: false },
			}
		case DECALER_ECHEANCE_RESET:
			return {
				...state,
				decalerEcheance: { saving: false, saved: false, error: false },
			}
		default:
			return state
	}
}
